<template>
    <div class="user-list-item__status bg-primary text-white" :class="{avatar: isAvatar}">
        <svg-icon-social class="user-list-item__svg"></svg-icon-social>
    </div>
</template>

<script>
import SvgIconSocial from '@/components/svg-icon/Social.vue';
export default {
    name: 'user-status-icon',
    components: {
        'svg-icon-social': SvgIconSocial
    },
    props: {
        bgColor: {
            type: String,
            default: 'primary'
        },
        isAvatar: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        classNames() {
            let bgcol = "xxx bg-" + this.bgColor;
            if(this.isAvatar === true) {
                bgcol = bgcol + " isAvatar";
            }
            return bgcol;
        }
    }
}
</script>

<style lang="scss">
    .user-list-view {
        .user-list-item__status.avatar {
            width: 90px !important;
            height: 90px !important;
            line-height: 75px;
        }
    }
</style>